import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const massiveImportRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.massiveImports,
    name: routeNames.massiveImports,
    component: () => import('@/pages/massive-imports/MassiveImportsView.vue'),
    meta: {
      permission: 'massive-imports.read.all',
      labelKey: 'massiveImports',
      icon: 'material-symbols-outlined',
      iconText: 'upload',
    },
  },
]
